export const CONTACTS_REQUEST = 'CONTACTS_REQUEST';
export const CONTACTS_REQUEST_SUCCESS = 'CONTACTS_REQUEST_SUCCESS';
export const CONTACTS_REQUEST_FAILED = 'CONTACTS_REQUEST_FAILED';
